<template>
    <div class="row">
        <div
            class="col-sm-3 text-center"
            v-show="records && records.length > 0"
            v-for="record in records"
            :key="record.id"
        >
            <div class="d-flex justify-content-center">
                <img :src="certificateImageUrl" width="90px"/>
            </div>
            <br>
            <div class="d-flex justify-content-center">
                <b class="text-capitalize">
                    {{ ((record.certificate == 'yes') ? 'Accreditation' : 'License') }} 
                    (
                        <small>
                            {{ record.date | getDateFormat }}
                        </small>
                    )
                </b>
            </div>
            <div class="d-flex justify-content-center">
                <small class="text-danger" v-if="(record.certificate == 'no')">
                    Expires on
                    {{ record.expiry_date | getDateFormat }}
                </small>
                <br v-if="(record.certificate == 'yes')">
            </div>

            <div class="d-flex justify-content-center">
                <form @submit.prevent="printCpdLicense">
                    <input type="hidden" name="id" :value="record.id" />
                    <input type="hidden" name="option" value="user" />
                    <input type="hidden" name="date" :value="record.date" />
                    <input type="hidden" name="expiry_date" :value="record.expiry_date" />
                    <input type="hidden" name="visit_date" :value="record.visit_date" />
                    <input type="hidden" name="ref_no" :value="record.ref_no" />
                    <input type="hidden" name="certificate" :value="record.certificate" />

                    <base-button
                        size="sm"
                        type="success"
                        nativeType="submit"
                    >
                        <i class="fa fa-print"></i>
                        Open Document
                    </base-button>

                </form>
            </div>
            <br>
        </div>

    </div>

</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import moment from 'moment';

    export default {
        name: 'LetterData',
        props: ['records'],
        filters: {
            getDateFormat(value) {
                return value ? moment(value).format('Do MMM, YYYY') : 'N/A';
            }
        },
        computed: {
            ...mapGetters(['certificateImageUrl', 'getRootUrl', 'cpd', 'getPrintCpdLicenseUrl'])
        },
        methods: {
            ...mapActions(['downloadAnyFiles']),
            printCpdLicense(event) {
                this.isLoading = true;
                const formData = new FormData(event.target);
                const payload = Object.fromEntries(formData.entries());// get entries

                const data = { 
                    ...payload, 
                    url : this.getPrintCpdLicenseUrl,
                    contentType : 'application/pdf',
                    fileName :  'print-letter.pdf',
                    msg : 'Failed to print letter:'
                };
                return this.downloadAnyFiles(data).then((res) => {// download file
                    this.isLoading = res; // stop loading
                });
            }
        }
    }
</script>

<style scoped>
    .height-50 {
        height: 50px;
    }
    .borderLine {
        border: 1px solid #ededed;
    }
</style>
